module.exports = __webpack_public_path__ + "img/22_24.f4aa2473.png";